namespace Solovis.InvDataSelectors {
    export type TransactionData = {
        transactionId: number,
        resourceId: number,
        label: string,
    }

    export class TransactionSelectorControl extends Solovis.UI.BaseControl {

        private _portalServices: Solovis.Portal.IPortalServices;

        private selectionCallback;
        private cancelCallback;
        /**
         * Optional caller-supplied check run against a successful find, before
         * selectionCallback is invoked. Return an error message to reject the found
         * transaction (shown the same way as a not-found error) instead of selecting it,
         * or a falsy value to accept it. Lets callers with extra business rules (e.g. "not
         * already linked to another Pro Forma group") reuse this control's error UI
         * without this generic selector knowing anything about those rules itself.
         */
        private validateSelection?: (transactionData: TransactionData) => string | null | undefined;

        private idInput;
        private _validationModel: Solovis.UI.InputControls.ValidationModel;

        constructor(options) {
            super(options);

            if (options.portalServices) {
                this._portalServices = options.portalServices;
            }
            else {
                this._portalServices = new Solovis.Portal.SitePortalServices();
            }

            // selectionCallback should be a function that takes an item.
            this.selectionCallback = options.selectionCallback ? options.selectionCallback : null;
            this.cancelCallback = options.cancelCallback ? options.cancelCallback : null;
            this.validateSelection = options.validateSelection ? options.validateSelection : null;

            this._validationModel = new Solovis.UI.InputControls.ValidationModel();
        }

        
        public doRender() {
            const self = this;

            $("<span>").text("Transaction ID").appendTo(this.container)
                .css("margin-right", "5px");

            this.idInput = $("<input>").attr("type", "text").appendTo(this.container)
                .css("margin-right", "5px");

            const findButton = $("<button>").text("Find").appendTo(this.container);

            // Same ValidationModel/ValidationModelControl pattern FormBuilder fields use
            // for error display elsewhere in the app
            const validationDiv = $("<div>").appendTo(this.container);
            const validationControl = new Solovis.UI.InputControls.ValidationModelControl({
                controlHost: validationDiv,
                validationModel: this._validationModel
            });
            validationControl.setAsCurrentControl();

            findButton.click(function () {
                self._validationModel.clearState();

                const transactionId = parseInt(self.idInput.val());

                self._portalServices.rpc().invoke("~/Selectors/TransactionSelector/GetTransactionData", { transactionId: transactionId },
                    function (response, success) {
                        if (success) {
                            const transactionData = response.result;

                            const validationError = self.validateSelection?.(transactionData);
                            if (validationError) {
                                self._validationModel.setErrorMessage(validationError);
                                return;
                            }

                            self.selectionCallback(transactionData);
                        }
                        else {
                            self._validationModel.setErrorMessage(response?.error?.message ?? "Transaction not found.");
                        }
                    });
            });

            // Trigger cancel when escape is pressed.
            $(this.idInput).keyup(function (e) {
                if (e.keyCode == 27) {
                    // Escape was pressed.
                    if (self.cancelCallback) {
                        self.cancelCallback();
                    }
                }
            });
        };

        public focus() {
            if (this.idInput) {
                this.idInput.focus();
            }
        };
    }

}